/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";
import { Sidebar, tituloBase } from "../../../shared";
import { Column } from "primereact/column";
import { InputSwitch } from "primereact/inputswitch";
import {
  Boton,
  Titulo,
  Formulario,
  CampoInformacion,
  accessAPI,
  formatFecha,
  TablaFiltrable
} from "../../../shared";

export default function AuditoriaSG() {
  const [loader, setLoader] = useState(true);
  const [auditoria, setAuditoria] = useState();
  const [loaderCrearUsuario, setLoaderCrearUsuario] = useState(false);
  const [formKeyUsuario, setFormKeyUsuario] = useState(0);
  const [sideBarUsuario, setSideBarUsuario] = useState(false);

  // Sidebar editar detalles
  const [sideBarEditar, setSideBarEditar] = useState(false);
  const [loaderEditar, setLoaderEditar] = useState(false);
  const [formEditarKey, setFormEditarKey] = useState(0);

  // Tipos de certificado disponibles y toggle en curso
  const [todosCertTipos, setTodosCertTipos] = useState(null);
  const [togglingCertTipoId, setTogglingCertTipoId] = useState(null);

  const navigate = useNavigate();
  const { auditoriaId } = useParams();
  const toast = useRef(null);
  const [loaderActiva, setLoaderActiva] = useState(false);

  function toggleActiva() {
    setLoaderActiva(true);
    accessAPI(
      "PUT",
      `admin/auditoriasg/${auditoriaId}/activa`,
      null,
      (respuesta) => {
        setAuditoria((prev) => ({ ...prev, activa: respuesta.activa }));
        setLoaderActiva(false);
      },
      (respuesta) => {
        setLoaderActiva(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cambiar estado",
          sticky: true
        });
      }
    );
  }

  useEffect(() => {
    // Cargar auditoría
    accessAPI(
      "GET",
      `admin/auditoriasg/${auditoriaId}`,
      null,
      (respuesta) => {
        setAuditoria(respuesta);
        document.title = respuesta.nombre;
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar auditoría",
          sticky: true
        });
      }
    );

    // Cargar todos los tipos de certificado disponibles
    accessAPI(
      "GET",
      "admin/config/certificadotipo",
      null,
      (respuesta) => setTodosCertTipos(respuesta),
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al cargar tipos de certificado",
          sticky: true
        });
      }
    );

    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function guardarEdicion(datosFormulario) {
    setLoaderEditar(true);
    accessAPI(
      "PUT",
      `admin/auditoriasg/${auditoriaId}`,
      datosFormulario,
      (respuesta) => {
        setAuditoria((prev) => ({ ...prev, ...respuesta }));
        document.title = respuesta.nombre;
        setLoaderEditar(false);
        setSideBarEditar(false);
        toast.current?.show({
          severity: "success",
          summary: "Guardado",
          detail: "Auditoría actualizada correctamente",
          life: 3000
        });
      },
      (respuesta) => {
        setLoaderEditar(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al actualizar",
          sticky: true
        });
      }
    );
  }

  function getEditarFormConfig() {
    return {
      secciones: [
        {
          campos: [
            {
              nombre: "nombre",
              tipoitemformularioid: 1,
              etiqueta: "Nombre",
              requerido: true,
              respuesta: auditoria?.nombre
            },
            {
              nombre: "fechaInicio",
              tipoitemformularioid: 7,
              etiqueta: "Fecha de inicio",
              requerido: true,
              respuesta: auditoria?.fechaInicio
                ? new Date(auditoria.fechaInicio)
                : null
            },
            {
              nombre: "fechaFin",
              tipoitemformularioid: 7,
              etiqueta: "Fecha de fin",
              requerido: true,
              respuesta: auditoria?.fechaFin
                ? new Date(auditoria.fechaFin)
                : null
            }
          ]
        }
      ],
      botones: [
        {
          etiqueta: "Guardar",
          callback: guardarEdicion,
          validar: true
        }
      ]
    };
  }

  function toggleCertificadoTipo(certTipo, activo) {
    setTogglingCertTipoId(certTipo.value);
    if (activo) {
      accessAPI(
        "PUT",
        `admin/auditoriasg/${auditoriaId}/certificadoTipo`,
        { certificadoTipoIds: [certTipo.value] },
        () => {
          setAuditoria((prev) => ({
            ...prev,
            certificadoTipos: [
              ...(prev.certificadoTipos || []),
              {
                id: certTipo.value,
                codigo: certTipo.codigo,
                nombre: certTipo.nombre
              }
            ],
            certificadoTipoId: [
              ...(prev.certificadoTipoId || []),
              certTipo.value
            ]
          }));
          setTogglingCertTipoId(null);
        },
        (respuesta) => {
          setTogglingCertTipoId(null);
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: respuesta[0]?.msg || "Error al agregar",
            sticky: true
          });
        }
      );
    } else {
      accessAPI(
        "DELETE",
        `admin/auditoriasg/${auditoriaId}/certificadoTipo`,
        { certificadoTipoId: certTipo.value },
        () => {
          setAuditoria((prev) => ({
            ...prev,
            certificadoTipos: (prev.certificadoTipos || []).filter(
              (t) => t.id !== certTipo.value
            ),
            certificadoTipoId: (prev.certificadoTipoId || []).filter(
              (id) => id !== certTipo.value
            ),
            procesosAuditados: prev.procesosAuditados?.filter(
              (pa) => pa.proceso?.certificadotipo?.id !== certTipo.value
            )
          }));
          setTogglingCertTipoId(null);
        },
        (respuesta) => {
          setTogglingCertTipoId(null);
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: respuesta[0]?.msg || "Error al eliminar",
            sticky: true
          });
        }
      );
    }
  }

  function crearUsuario(datosFormulario) {
    setLoaderCrearUsuario(true);
    accessAPI(
      "POST",
      `admin/auditoriasg/${auditoriaId}/usuario`,
      datosFormulario,
      (respuesta) => {
        setLoaderCrearUsuario(false);
        setFormKeyUsuario((prev) => prev + 1);
        setSideBarUsuario(false);
        toast.current?.show({
          severity: "success",
          summary: "Usuario creado",
          detail: respuesta.msg || "Usuario creado correctamente",
          life: 5000
        });
      },
      (respuesta) => {
        setLoaderCrearUsuario(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear usuario",
          sticky: true
        });
      }
    );
  }

  const formularioUsuarioConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "email",
            tipoitemformularioid: 2,
            etiqueta: "Email de destino",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear usuario",
        callback: crearUsuario,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />

      {loader && (
        <div>
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1em"
            }}
          >
            <Skeleton width="16rem" height="2rem" />
          </div>
          <Skeleton width="100%" height="15rem" />
        </div>
      )}

      {auditoria && !loader && (
        <>
          <Titulo
            urlVolver="/auditoriasg"
            etiqueta={!auditoria.activa ? "Desactivada" : null}
            error={!auditoria.activa}
            botones={
              <>
                <Boton
                  callback={() => {
                    setFormKeyUsuario((prev) => prev + 1);
                    setSideBarUsuario(true);
                  }}
                >
                  Agregar usuario
                </Boton>
                <Boton
                  rojo
                  transparente
                  callback={toggleActiva}
                  loader={loaderActiva}
                >
                  {auditoria.activa ? "Desactivar" : "Activar"}
                </Boton>
              </>
            }
          >
            {auditoria.nombre}
          </Titulo>

          <Sidebar
            visible={sideBarEditar}
            onHide={() => setSideBarEditar(false)}
            position="right"
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>Editar auditoría</Titulo>
            <Formulario
              config={getEditarFormConfig()}
              loader={loaderEditar}
              key={formEditarKey}
            />
          </Sidebar>

          <Card>
            <Titulo
              botones={
                <Boton
                  texto
                  negro
                  callback={() => {
                    setFormEditarKey((prev) => prev + 1);
                    setSideBarEditar(true);
                  }}
                >
                  <i className="pi pi-pencil" />
                </Boton>
              }
            >
              Detalles
            </Titulo>
            <div className="grid">
              <CampoInformacion nombreCampo="Nombre">
                {auditoria.nombre}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Fecha Inicio">
                {formatFecha(auditoria.fechaInicio) || "—"}
              </CampoInformacion>
              <CampoInformacion nombreCampo="Fecha Fin">
                {formatFecha(auditoria.fechaFin) || "—"}
              </CampoInformacion>
            </div>
          </Card>

          <div className="grid" css={{ marginTop: "1em" }}>
            <div className="col-12 lg:col-6">
              <Card>
                <Titulo>Tipos de Certificado</Titulo>
                {!todosCertTipos && (
                  <div
                    css={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.5em"
                    }}
                  >
                    {[1, 2, 3, 4].map((i) => (
                      <Skeleton key={i} width="100%" height="2.2em" />
                    ))}
                  </div>
                )}
                {todosCertTipos && todosCertTipos.length === 0 && (
                  <p css={{ color: "var(--grisTextos)" }}>
                    No hay tipos de certificado disponibles
                  </p>
                )}
                {todosCertTipos &&
                  todosCertTipos.map((certTipo) => {
                    const activo = (auditoria.certificadoTipoId || []).includes(
                      certTipo.value
                    );
                    return (
                      <div
                        key={certTipo.value}
                        css={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "0.5em 0",
                          borderBottom: "1px solid #eee"
                        }}
                      >
                        <div>
                          <strong>{certTipo.nombre}</strong>
                        </div>
                        <div css={{ flexShrink: 0 }}>
                          <InputSwitch
                            checked={activo}
                            onChange={(e) =>
                              toggleCertificadoTipo(certTipo, e.value)
                            }
                            disabled={togglingCertTipoId !== null}
                          />
                        </div>
                      </div>
                    );
                  })}
              </Card>
            </div>

            <div className="col-12 lg:col-6">
              <Card>
                <Titulo>
                  Procesos Auditados
                </Titulo>
                <TablaFiltrable conFiltros={false}
                  value={auditoria.procesosAuditados || []}
                  size="small"
                  emptyMessage="No hay procesos auditados"
                  selectionMode="single"
                  onRowSelect={(e) => navigate(`/proceso/${e.data.proceso.id}`)}
                  rowHover
                  nombreArchivo="procesos_auditados"
                >
                  <Column
                    header="Código"
                    body={(rowData) => rowData.proceso?.nombre || "-"}
                    style={{ width: "6rem" }}
                  />
                  <Column
                    header="Cliente"
                    body={(rowData) =>
                      rowData.proceso?.cliente?.razonsocial || "—"
                    }
                  />
                  <Column
                    header="Tipo Certificado"
                    body={(rowData) =>
                      rowData.proceso?.certificadotipo?.nombre || "—"
                    }
                  />
                </TablaFiltrable>
              </Card>
            </div>
          </div>

          <Sidebar
            visible={sideBarUsuario}
            onHide={() => setSideBarUsuario(false)}
            position="right"
            className="w-full lg:w-30rem md:w-30rem"
          >
            <Titulo>Agregar usuario</Titulo>
            <p style={{ color: "var(--grisTextos)", marginBottom: "15px" }}>
              Se generará un usuario con credenciales aleatorias y se enviarán
              al email indicado.
            </p>
            <Formulario
              config={formularioUsuarioConfig}
              loader={loaderCrearUsuario}
              key={formKeyUsuario}
            />
          </Sidebar>
        </>
      )}
    </>
  );
}
